module.exports = __webpack_public_path__ + "static/hudl@2x-1488e5bddc7e57eb0685f01294f587b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/customer-stories/hudl@2x.jpg
// module id = 869
// module chunks = 33019919093843 122353984331245